import React, { Component } from 'react';
// import PropTypes from 'prop-types';
import ThreeDotMenuBase from './ThreeDotMenuBase';

class ThreeDotMenu extends Component {
  render() {
    return <ThreeDotMenuBase {...this.props} />;
  }
}

export default ThreeDotMenu;
